<template>
  <div>
    <div class="panel-heading">
      <h4 class="panel-title">Purchased Orders</h4>
    </div>

    <div
      class="panel-body"
      style="display: block;"
    >
      <div class="row">
        <preDatatableComponent
          :permissions="{
            generate_qr_code: 'purchase_generate_qrcode',
            send_to_warehouse: 'send_to_warehouse',
          }"
          :removeAddButton="true"
          :removeWarehouseDeliverButton="false"
          :openSendToWarehouseModal="openSendToWarehouseModal"
          :addQrCodeGenerateButton="true"
          :openGenerateQrCodeModal="openGenerateQrCodeModal"
          :addExportButton="true"
          :sendToExport="sendToExport"
          :tableData="tableData"
          :resetGetResults="resetGetResults"
          :searchMe="searchMe"
          :pagination="pagination"
          :perPageFix="perPageFix"
          :filterTable="filterTable"
          :resetGetResults2="resetGetResults2"
          :columns="columns"
          :showHideColumn="showHideColumn"
          :filterMade="filterMade"
          :totalResult="totalResult"
          @branch-edit="branchEdit"
        ></preDatatableComponent>
        <div class="col-xs-12 pt-0">
          <v-layout
            row
            wrap
          >
            <v-flex
              xs5
              sm4
              md5
              lg3
              class="pl-3"
            >
              <v-checkbox
                hide-details
                label="Warehouse Passed"
                @change="getResults()"
                v-model="tableData.wh_dt_passed"
                true-value="1"
                false-value="0"
              />
            </v-flex>
          </v-layout>
          <datatable
            v-if="!isMobile"
            :sortDir="tableData.sortDir"
            :columns="columns"
            :sortByColumn="sortByColumn"
            :searchOneCol="searchOneCol"
            :sortKey="sortKey"
            :sortOrders="sortOrders"
            :checkAll="checkAll"
            :unCheckAll="unCheckAll"
          >
            <tbody>
              <tr
                v-for="(r, index) in apiResults"
                :key="r.order_id"
                :style="qrCodeValues.find(x => x[0] == r.order_id) ? 'background-color: #FFF9C4' : (r.is_ship_only == '1' ? 'background-color: #A5D6A7' : getRowStyle(r)) "
                class="table-tr"
              >
                <td>
                  <input
                    :id="'cb' + index"
                    type="checkbox"
                    :value="[
                      r.order_id,
                      r.full_name,
                      r.phone_number,
                      r.user_id,
                      r.theOrderID,
                      r.is_ship_only,
                    ]"
                    v-model="qrCodeValues"
                  />
                  <!-- r.deliver_branch_name,
                      r.deliver_branch_id_fk, -->
                </td>
                <!-- <td>
                  <display-branch :data="r" />
                </td> -->
                <td>{{ r.order_id }}</td>
                <td v-if="r.qrcode == null || r.qrcode == ''">{{ r.theOrderID }}</td>
                <td v-else><i
                    class="fa fa-qrcode"
                    aria-hidden="true"
                  ></i> {{ r.theOrderID }}</td>
                <!-- <td>{{ r.user_id }}</td> -->
                <td style="max-width: 200px">{{ r.track_number }}</td>
                <td class="ws-nowrap">
                  {{ r.full_name }}
                  <open-whatsapp-and-viber :phoneNumber="r.phone_number" />
                </td>
                <td>
                  <a
                    :href="r.product_url"
                    target="_blank"
                  >{{
                    r.product_url.replace(/http(s)?:\/\//, '').substr(0, 25) +
                      (r.product_url.length > 25 ? '...' : '')
                  }}</a>
                </td>
                <td>{{ r.product_name }}</td>
                <td>{{ r.quantity }}</td>
                <td>
                  <span v-if="r.country == 'USA'">
                    <flag iso="um" />
                  </span>
                  <span v-else-if="r.country == 'Turkey'">
                    <flag iso="tr" />
                  </span>
                  <span v-else-if="r.country == 'China'">
                    <flag iso="cn" />
                  </span>
                  <span v-else-if="r.country == 'German'">
                    <flag iso="de" />
                  </span>
                  <span v-else-if="r.country == 'UK'">
                    <flag iso="gb" />
                  </span>
                  &nbsp; {{ r.country }}
                </td>
                <td>{{ r.purchase_note }}</td>
                <td>{{ r.note }}</td>
                <td
                  style="min-width: 130px"
                  class="date-container"
                >
                  <view-order-dates :orderData="r" />
                </td>
                <td>{{ r.warehouse_date }}</td>
                <td>{{ r.barcode }}</td>
                <td>{{ r.bank_name }}</td>
                <td class="action-td">
                  <!-- style="position: sticky; right: 0" -->
                  <div
                    class="action-container"
                    style="display: flex;"
                  >
                    <a
                      v-if="$_has_perm('view_order_detail')"
                      style="color:#01579B; padding: 0px 6px"
                      tooltip="View Details"
                      @click="initDetail('modal_showApp', r.order_id)"
                    >
                      <i class="material-icons">aspect_ratio</i>
                    </a>

                    <a
                      v-if="$_has_perm('purchase_cancel_order') && r.is_ship_only == '1'"
                      style="color: #c62828; padding: 0px 6px"
                      tooltip="Cancel This Order"
                      @click="openCancelingOrderModal(r.order_id)"
                    ><i class="material-icons">cancel</i></a>

                    <a
                      v-if="$_has_perm('refund_purchased_order')"
                      style="color:#C62828; padding: 0px 6px"
                      tooltip="Refund This Order"
                      @click="openRefundOrderModal(r.order_id, r.total_amount)"
                    >
                      <i class="material-icons">block</i>
                    </a>

                    <a
                      v-if="$_has_perm('add_track_number')"
                      style="color:rgb(4, 137, 151); padding: 0px 6px"
                      tooltip="Add Track number"
                      @click="openAddTrackNumberModal(r.order_id, r.track_number)"
                    >
                      <i class="material-icons">add_box</i>
                    </a>

                    <a
                      v-if="$_has_perm('add_bitemid')"
                      style="color:#00796B; padding: 0px 6px"
                      tooltip="Add bitemid"
                      @click="openAddBarcodeModal(r.order_id, r.barcode)"
                    >
                      <i class="material-icons">add_circle</i>
                    </a>

                    <a
                      v-if="$_has_perm('add_warehouse_date')"
                      style="color:#5579fB; padding: 0px 6px"
                      tooltip="Add warehouse date"
                      @click="openAddWarehouseDateModal(r.order_id, r.warehouse_date)"
                    >
                      <i class="material-icons">add</i>
                    </a>

                    <a
                      v-if="$_has_perm('add_partial_refund')"
                      style="padding-left: 6px; padding-right: 6px; color: #FF5722;"
                      tooltip="Partial Refund"
                      @click="openPartialRefundOrderModal(r.order_id, r.total_amount)"
                    >
                      <i
                        class="fa fa-registered"
                        style="font-size: 1.7em"
                      ></i>
                    </a>
                    <a
                      v-if="$_has_perm('add_order_case')"
                      class="px-2"
                      @click="openCreateOrderCaseModal(r)"
                      style="color: #555"
                      tooltip="Create Case"
                    >
                      <i
                        class="fa fa-folder-open"
                        style="font-size: 1.6rem"
                      />
                    </a>
                  </div>
                </td>
              </tr>
              <tr id="no-result-row">
                <td
                  :colspan="columns.length"
                  class="text-center"
                >
                  <v-alert
                    type="error"
                    :value="alertValue"
                  >
                    No Results Found
                  </v-alert>
                </td>
              </tr>
            </tbody>
          </datatable>

          <mobile-datatable
            v-if="isMobile"
            :isPurchase="true"
            :checkAll="checkAll"
            :unCheckAll="unCheckAll"
            :isOrder="true"
          >
            <tbody>
              <tr
                v-for="(r, index) in apiResults"
                :key="r.order_id"
              >
                <td>
                  <input
                    :id="'cb' + index"
                    type="checkbox"
                    :value="[r.order_id, r.full_name, r.phone_number, r.user_id, r.theOrderID]"
                    v-model="qrCodeValues"
                  />
                </td>
                <td>
                  <span v-if="r.qrcode == null || r.qrcode == ''">{{ r.theOrderID }}</span>
                  <span v-else><i
                      class="fa fa-qrcode"
                      aria-hidden="true"
                    ></i> {{ r.theOrderID }}</span>
                  <br />{{ r.product_name }} , <br />
                  <a
                    :href="r.product_url"
                    target="_blank"
                  >{{
                    r.product_url.replace(/http(s)?:\/\//, '').substr(0, 25) +
                      (r.product_url.length > 25 ? '...' : '')
                  }}</a>
                  <br />
                  <span v-if="r.country == 'USA'">
                    <flag iso="um" />
                  </span>
                  <span v-else-if="r.country == 'Turkey'">
                    <flag iso="tr" />
                  </span>
                  <span v-else-if="r.country == 'China'">
                    <flag iso="cn" />
                  </span>
                  <span v-else-if="r.country == 'German'">
                    <flag iso="de" />
                  </span>
                  <span v-else-if="r.country == 'UK'">
                    <flag iso="gb" />
                  </span>
                  &nbsp; {{ r.country }} ,
                  <br />
                  PurchaseNote: {{ r.purchase_note }}
                  <br />
                  Quantity: {{ r.quantity }}
                  <br />
                  QrValue : {{ r.order_id }}
                </td>
                <td>
                  Customer Name: {{ r.full_name }} , <br />
                  <span v-if="r.order_date != null">{{ r.order_date }}</span>
                  <span v-else>{{ r.created_at }}</span> <br />
                  Confirm date: {{ r.confirm_date }} , <br />
                  <span v-if="r.track_number != null">Track No: {{ r.track_number }}, <br /></span>
                  <span v-if="r.barcode != null">Bitemid: {{ r.barcode }}, <br /> </span>
                  <a
                    v-if="$_has_perm('view_order_detail')"
                    style="color:#01579B; display: inline-block; padding-right: 3px"
                    tooltip="View Details"
                    @click="initDetail('modal_showApp', r.order_id)"
                  >
                    <i class="material-icons">aspect_ratio</i>
                  </a>
                  <span
                    v-if="$_has_perm('refund_purchased_order')"
                    style="padding-left:1px; padding-right:2px; float: left"
                  >
                    <a
                      style="color:#C62828"
                      tooltip="Refund This Order"
                      @click="openRefundOrderModal(r.order_id, r.total_amount)"
                    >
                      <i class="material-icons">block</i></a>
                  </span>
                  <span
                    v-if="$_has_perm('add_track_number')"
                    style="padding-left:0px; padding-right:2px; float: left"
                  >
                    <a
                      style="color:rgb(4, 137, 151)"
                      tooltip="Add Track number"
                      @click="openAddTrackNumberModal(r.order_id)"
                    >
                      <i class="material-icons">add_box</i></a>
                  </span>
                  <span
                    v-if="$_has_perm('add_bitemid')"
                    style="padding-left:0px; padding-right:60px; float: right"
                  >
                    <a
                      style="color:#00796B"
                      tooltip="Add bitemid"
                      @click="openAddBarcodeModal(r.order_id)"
                    >
                      <i class="material-icons">add_circle</i></a>
                  </span>
                  <span
                    v-if="$_has_perm('add_warehouse_date')"
                    style="padding-left:0px; padding-right:60px; float: right"
                  >
                    <a
                      style="color:#5579fB; padding: 0px 6px"
                      tooltip="Add warehouse date"
                      @click="openAddWarehouseDateModal(r.order_id, r.warehouse_date)"
                    >
                      <i class="material-icons">add</i>
                    </a>
                  </span>
                </td>
              </tr>
              <tr id="no-result-row">
                <td
                  colspan="2"
                  class="text-center"
                >
                  <v-alert
                    type="error"
                    :value="alertValue"
                  >
                    No Results Found
                  </v-alert>
                </td>
              </tr>
            </tbody>
          </mobile-datatable>

          <view-order-details
            :detialData="detialData"
            :closeModal="closeModal"
          ></view-order-details>

          <create-qr-code
            :openGenerateQrCodeModal="openGenerateQrCodeModal"
            :generateQrCodeModal="generateQrCodeModal"
            :closeGenerateQrCodeModal="closeGenerateQrCodeModal"
            :qrCodeValues="qrCodeValues"
            :generateQrCode="generateQrCode"
            :getResults="getResults"
          ></create-qr-code>

          <send-to-warehouse
            :sendToWarehouseModal="sendToWarehouseModal"
            :closeSendToWarehouseModal="closeSendToWarehouseModal"
            :sendToWarehouseData="sendToWarehouseData"
            :sendToWarehouse="sendToWarehouse"
          ></send-to-warehouse>

          <refunding-order
            :refundOrderModal="refundOrderModal"
            :refundOrder="refundOrder"
            :refundData="refundData"
            :checkAlert="checkAlert"
            :closeRefundOrderModal="closeRefundOrderModal"
            :loading="loading"
            :theOrderTotalAmount="theOrderTotalAmount"
          ></refunding-order>

          <add-barcode
            :addBarcodeModal="addBarcodeModal"
            :addBarcode="addBarcode"
            :addBarcodeData="addBarcodeData"
            :checkAlert="checkAlert"
            :closeAddBarcodeModal="closeAddBarcodeModal"
          ></add-barcode>

          <add-track-number
            :addTrackNumberModal="addTrackNumberModal"
            :addTrackNumber="addTrackNumber"
            :addTrackNumberData="addTrackNumberData"
            :checkAlert="checkAlert"
            :closeAddTrackNumberModal="closeAddTrackNumberModal"
          ></add-track-number>

          <take-order-image
            :order_id_fk="oID"
            :takeOrderImageDialog="takeOrderImageDialog"
          />

          <add-warehouse-date
            :addWarehouseDateModal="addWarehouseDateModal"
            :warehouseDateData="warehouseDateData"
            :closeWarehouseDateModal="closeWarehouseDateModal"
            :submitWarehouseDate="submitWarehouseDate"
          />

          <take-photo
            :takePhotoModal="takePhotoModal"
            :orderData="orderData"
            @close="takePhotoModal = false"
          />

          <partial-refunding-order
            :partialRefundOrderModal="partialRefundOrderModal"
            :partialRefundOrder="partialRefundOrder"
            :partialRefundData="partialRefundData"
            :theOrderTotalAmount="theOrderTotalAmount"
            :checkAlert="checkAlert"
            :closePartialRefundOrderModal="closePartialRefundOrderModal"
            :loading="loading"
          ></partial-refunding-order>

          <add-edit-order-case
            :addEditOrderCaseModal="addEditOrderCaseModal"
            :formData="formData"
            :isUpdate="isUpdate"
            @close="addEditOrderCaseModal = false"
          />

          <admin-cancel-order
            :closeCancelingOrderModal="closeCancelingOrderModal"
            :cancelOrderModal="cancelOrderModal"
            :cancelAlert="cancelAlert"
            :cancelData="cancelData"
            :cancelingOrder="cancelingOrder"
          ></admin-cancel-order>

          <hr />
          <div class="row">
            <div class="col-xs-12 text-right">
              <paginate
                :page-count="pagination.lastPage"
                :page-range="2"
                :changePage="changePage"
                :container-class="'pagination'"
                :pagination="pagination"
                :page-class="'page-item'"
              >
              </paginate>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PaginationVue from './Pagination.vue'
import preDatatableComponent from './preDatatableComponent.vue'
import DatatableVue from './Datatable.vue'
import viewOrderDetails from './viewOrderDetails.vue'
import axios from 'axios'
import swal from 'sweetalert'
import createQrCode from './createQrCode.vue'
import sendToWarehouse from './sendToWarehouse.vue'
import refundingOrder from './refundingOrder.vue'
import addBarcode from './addBarcode.vue'
import addTrackNumber from './addTrackNumber.vue'
import mobileDatatable from './mobileDatatable'
import takeOrderImage from './takeOrderImage'
import addWarehouseDate from './addWarehouseDate'
import takePhoto from './takePhoto.vue'
import partialRefundingOrder from './partialRefundingOrder.vue'
import addEditOrderCase from './orderCase/addEditOrderCase.vue'
import adminCancelOrder from './adminCancelOrder'

export default {
  components: {
    preDatatableComponent: preDatatableComponent,
    datatable: DatatableVue,
    paginate: PaginationVue,
    'view-order-details': viewOrderDetails,
    'create-qr-code': createQrCode,
    'send-to-warehouse': sendToWarehouse,
    'refunding-order': refundingOrder,
    'add-barcode': addBarcode,
    'add-track-number': addTrackNumber,
    'mobile-datatable': mobileDatatable,
    'admin-cancel-order': adminCancelOrder,
    takeOrderImage,
    addWarehouseDate,
    takePhoto,
    partialRefundingOrder,
    addEditOrderCase
  },
  created() {
    this.getLoggedInUser()
  },
  mounted() {
    this.perPageFix()

    if (screen.width <= 600) {
      this.isMobile = true
    } else {
      this.isMobile = false
    }
  },
  $_veeValidate: {
    validator: 'new',
  },
  data() {
    let sortOrders = {}
    let columns = [
      { label: '', name: '', text: 'Check box', value: '1' },
      // {
      //   label: 'Branches',
      //   text: 'Branches',
      //   value: '2',
      //   sortable: false,
      //   searchable: false,
      //   name: 'branches'
      // },
      {
        label: 'Qr ID',
        text: 'Qr ID',
        value: '2',
        sortable: true,
        searchable: true,
        name: 'order_id',
      },
      {
        label: 'OrderID',
        text: 'OrderID',
        value: '3',
        sortable: true,
        searchable: true,
        name: 'theOrderID',
      },
      {
        label: 'Track Number',
        text: 'Track Number',
        value: '4',
        sortable: true,
        searchable: true,
        name: 'track_number',
      },
      // {
      //   label: 'Customer ID',
      //   text: 'Customer ID',
      //   value: '3',
      //   sortable: true,
      //   searchable: true,
      //   name: 'user_id'
      // },
      {
        label: 'Customer Name',
        text: 'Customer Name',
        value: '5',
        sortable: true,
        searchable: true,
        name: 'full_name',
      },
      {
        label: 'Product URL',
        text: 'Product URL',
        value: '6',
        sortable: true,
        searchable: true,
        name: 'product_url',
      },
      {
        label: 'Product Name',
        text: 'Product Name',
        value: '7',
        sortable: true,
        searchable: true,
        name: 'product_name',
      },
      {
        label: 'Quantity',
        text: 'Quantity',
        value: '8',
        sortable: true,
        searchable: true,
        name: 'quantity',
      },
      {
        label: 'Warehouse',
        text: 'Warehouse',
        value: '9',
        sortable: true,
        searchable: true,
        name: 'country',
      },
      {
        label: 'Purchase Note',
        text: 'Purchase Note',
        value: '10',
        sortable: true,
        searchable: true,
        name: 'purchase_note',
      },
      {
        label: 'Order Note',
        text: 'Order Note',
        value: '11',
        sortable: true,
        searchable: true,
        name: 'note',
      },
      {
        label: 'Date',
        text: 'Date',
        value: '12',
        sortable: true,
        searchable: false,
        name: 'purchase_date',
      },
      {
        label: 'Warehouse Date',
        text: 'Warehouse Date',
        value: '13',
        sortable: true,
        searchable: false,
        name: 'warehouse_date',
      },
      {
        label: 'Bitemid',
        text: 'Bitemid',
        value: '14',
        sortable: true,
        searchable: true,
        name: 'barcode',
      },
      {
        label: 'Bank',
        text: 'Bank',
        value: '15',
        sortable: true,
        searchable: true,
        name: 'bank_name',
      },
    ]
    columns.forEach((column) => {
      sortOrders[column.name] = -1
    })

    return {
      isMobile: false,
      loading: false,
      url: 'api/purchased_order',
      sendToWarehouseUrl: 'api/warehouse_delivering_order',
      orderDetailUrl: 'api/show_order_detail',
      refundOrderUrl: 'api/refunding_order',
      addBarcodeUrl: 'api/add_barcode',
      addTrackNumberUrl: 'api/add_track_number',
      qrCodeValues: [],
      loggedInUserData: {},
      addWarehouseDateModal: false,
      warehouseDateData: {},
      theCancelOrderID: '',
      cancelOrderModal: false,
      cancelAlert: false,
      cancelData: {
        cancel_reason: ''
      },
      sendToWarehouseData: {
        qrcode: '',
      },
      alertValue: false,
      checkAlert: false,
      filterMade: false,
      totalResult: 0,
      generateQrCodeModal: false,
      sendToWarehouseModal: false,
      refundOrderModal: false,
      queryParameter: true,
      the_order_id: '',
      btnsave: true,
      addBarcodeModal: false,
      addTrackNumberModal: false,
      the_order_id2: '',
      the_order_id3: '',
      oID: null,
      orderData: {},
      takePhotoModal: false,
      takeOrderImageDialog: false,
      formData: {},
      isUpdate: false,
      addEditOrderCaseModal: false,
      addBarcodeData: {
        barcode: '',
      },
      addTrackNumberData: {
        track_number: '',
      },
      updateData: {
        order: [],
      },
      refundData: {
        refund_reason: '',
        money_amount: '',
        refund_note: '',
        send_sms: false,
      },
      detialData: {
        the_tl_price: '',
        order_id: '',
        bank_name: '',
        discount: '',
        full_name: '',
        email: '',
        phone_number: '',
        c_o_d: '',
        product_url: '',
        product_name: '',
        description: '',
        size: '',
        type: '',
        status: '',
        color: '',
        quantity: '',
        quantity_charge: '',
        coupon: '',
        qrcode: '',
        barcode: '',
        delivery_type: '',
        item_price: '',
        tax: '',
        item_weight: '',
        internal_shipping_handling: '',
        kreenex_fee: '',
        delivery_price: '',
        insurance: '',
        total_amount: '',
        from_date: '',
        to_date: '',
        confirm_date: '',
        refund_reason: '',
        country: '',
        order_date: '',
        track_number: '',
        item_type: '',
        note: '',
      },
      prevSearchQuery: '',
      apiResults: [],
      detailResults: [],
      theOrderTotalAmount: '',
      columns: columns,
      sortKey: 'updated_at',
      sortOrders: sortOrders,
      tableData: {
        per_page: 10,
        search: '',
        column: 'orders.updated_at',
        sortDir: 'desc',
        searchOneCol: '',
        searchOneVal: '',
        from_date: '',
        to_date: '',
        wh_dt_passed: 0,
        branches_id: ''
      },
      pagination: {
        lastPage: 1,
        currentPage: 1,
        total: 1,
        lastPageUrl: '',
        nextPageUrl: '',
        prevPageUrl: '',
        from: '',
        to: '',
      },
      partialRefundOrderModal: false,
      partialRefundData: {}
    }
  },

  methods: {
    sendToExport() {
      let searchValue = this.tableData.search !== '' ? this.tableData.search : '0'
      let column = this.tableData.column !== '' ? this.tableData.column : '0'
      let sortDir = this.tableData.sortDir !== '' ? this.tableData.sortDir : '0'
      let searchedOneCol = this.tableData.searchOneCol !== '' ? this.tableData.searchOneCol : '0'
      let searchedOneVal = this.tableData.searchOneVal !== '' ? this.tableData.searchOneVal : '0'
      let fromDate = this.tableData.from_date !== '' ? this.tableData.from_date : '0'
      let toDate = this.tableData.to_date !== '' ? this.tableData.to_date : '0'
      let whDtPassed = this.tableData.wh_dt_passed !== '' ? this.tableData.wh_dt_passed : '0'
      let loggedInUserData = JSON.parse(localStorage.getItem('user_data'))
      let warehouses = loggedInUserData.warehouse_id_fk
      let perPage = this.tableData.per_page == null ? 10 : this.tableData.per_page
      if (
        searchValue !== '0' ||
        searchedOneCol !== '0' ||
        searchedOneVal !== '0' ||
        toDate !== '0' ||
        fromDate !== '0'
      ) {
        perPage = '0'
      }

      let hostName = window.location.hostname
      let protocol = window.location.protocol + '//'
      let fullHostName = protocol + hostName

      window.location.replace(
        fullHostName +
        '/api/purchased-order-export?searchValue=' +
        searchValue +
        '&column=' +
        column +
        '&sortDir=' +
        sortDir +
        '&searchedOneCol=' +
        searchedOneCol +
        '&searchedOneVal=' +
        searchedOneVal +
        '&from_date=' +
        fromDate +
        '&to_date=' +
        toDate +
        '&warehouses=' +
        warehouses +
        '&per_page=' +
        perPage +
        '&wh_dt_passed=' +
        whDtPassed
      )
    },

    openCreateOrderCaseModal(order) {
      this.formData = {
        order_id_fk: order.order_id,
        order: order,
        note: null
      }
      this.isUpdate = false
      this.addEditOrderCaseModal = true
    },

    openPartialRefundOrderModal(orderId, totalAmount) {
      this.partialRefundData = { order_id_fk: orderId }
      this.theOrderTotalAmount = totalAmount
      this.partialRefundOrderModal = true
    },

    closePartialRefundOrderModal() {
      this.partialRefundOrderModal = false
      this.checkAlert = false
      this.partialClear()
    },

    partialClear() {
      this.partialRefundData = {}
      this.theOrderTotalAmount = ''
      this.$validator.reset()
    },

    partialRefundOrder() {
      let token = localStorage.getItem('access_token')
      this.loading = true
      axios.post('api/partial-refund', this.partialRefundData, {
        headers: { Authorization: 'Bearer ' + token }
      }).then((response) => {
        this.getResults()
        this.checkAlert = true
        this.loading = false
        setTimeout(() => {
          this.clear()
          this.closePartialRefundOrderModal()
        }, 1500)
      }).catch(error => {
        swal('Error', `${error.response.data.message}`, 'error')
        this.getResults()
        this.loading = false
      })
    },

    branchEdit(branches) {
      this.tableData.branches_id = branches.toString()
      this.getResults()
    },

    openAddWarehouseDateModal(orderId, warehouseDate) {
      this.addWarehouseDateModal = true
      this.warehouseDateData = {
        order_id: orderId,
        warehouse_date: warehouseDate
      }
    },

    closeWarehouseDateModal() {
      this.addWarehouseDateModal = false
      this.warehouseDateData = {}
    },

    submitWarehouseDate() {
      let token = localStorage.getItem('access_token')

      axios
        .post('/api/change-warehouse-date', this.warehouseDateData, {
          headers: { Authorization: 'Bearer ' + token },
        })
        .then(() => {
          swal('Success', 'Warehouse date changed', 'success')
          this.closeWarehouseDateModal()
          this.getResults()
        })
        .catch((error) => {
          swal('Error', `${error.response.data.message}`, 'error')
        })
    },

    getRowStyle(data) {
      let today = new Date()
      let warehouseDate = new Date(data.warehouse_date)
      let next8Days = new Date(warehouseDate.getTime())
      next8Days.setDate(next8Days.getDate() + 8)

      if (next8Days < today) return 'background-color: #FFAB91'

      return ''
    },

    openTakeOrderImageModal(orderId) {
      this.oID = orderId
      this.takeOrderImageDialog = true
    },

    showHideColumn(prevColVal, currentColVal) {
      let a = []
      let diff = []

      if (currentColVal.length < prevColVal.length) {
        for (let i = 0; i < prevColVal.length; i++) {
          a[prevColVal[i]] = true
        }

        for (let i = 0; i < currentColVal.length; i++) {
          if (a[currentColVal[i]]) {
            delete a[currentColVal[i]]
          } else {
            a[currentColVal[i]] = true
          }
        }

        for (let k in a) {
          diff.push(k)
        }

        for (let c = 0; c < diff.length; c++) {
          $('td:nth-child(' + diff[c] + '),th:nth-child(' + diff[c] + ')').toggle()
        }
      } else {
        for (let i = 0; i < currentColVal.length; i++) {
          let visible = $(
            'td:nth-child(' + currentColVal[i] + '),th:nth-child(' + currentColVal[i] + ')'
          ).is(':visible')
          if (visible) {
            $(
              'td:nth-child(' + currentColVal[i] + '),th:nth-child(' + currentColVal[i] + ')'
            ).toggle()
          }
        }
      }
    },

    resetGetResults2() {
      this.queryParameter = false
      this.tableData.searchOneCol = ''
      this.tableData.searchOneVal = ''
      this.tableData.search = ''
      this.sortKey = 'updated_at'
      this.tableData.sortDir = 'desc'
      this.tableData.column = 'updated_at'
      this.tableData.from_date = ''
      this.tableData.to_date = ''
      this.tableData.wh_dt_passed = '0'
      this.getResults()
    },

    getLoggedInUser() {
      this.loggedInUserData = JSON.parse(localStorage.getItem('user_data'))
    },

    getResults(url = this.url) {
      var token = localStorage.getItem('access_token')
      let theDatatable = document.querySelector('.the-datatable')
      let thePanel = document.querySelector('.panel-flat')

      if (theDatatable != null) {
        theDatatable.classList.add('slide-table-out')
        thePanel.style.overflowX = 'auto'
      }

      axios
        .get(url, { params: this.tableData, headers: { Authorization: 'Bearer ' + token } })
        .then((response) => {
          let data = response.data
          if (data.data.length > 0) {
            this.filterMade = true
            this.apiResults = data.data
          } else {
            this.filterMade = false
            this.apiResults = data.data.data
          }

          if (this.apiResults.length === 0) {
            this.tableData.searchOneCol = ''
            this.tableData.searchOneVal = ''
            this.tableData.search = ''
            this.alertValue = true
          } else {
            this.alertValue = false
          }
          if (data.data.length > 0) {
            this.removeConfigPagination()
          } else {
            this.configPagination(data.data)
          }
          theDatatable.classList.remove('slide-table-out')
          setTimeout(function () {
            thePanel.style.overflowX = 'auto'
          }, 0)
        })
        .then(() => {
          this.totalResult = 0
          for (let i = 0; i < this.apiResults.length; i++) {
            this.totalResult += 1
          }
        })
    },

    removeConfigPagination() {
      this.pagination.lastPage = ''
      this.pagination.currentPage = ''
      this.pagination.total = ''
      this.pagination.lastPageUrl = ''
      this.pagination.nextPageUrl = ''
      this.pagination.prevPageUrl = ''
      this.pagination.from = ''
      this.pagination.to = ''
    },

    resetGetResults() {
      this.queryParameter = false
      this.tableData.searchOneCol = ''
      this.tableData.searchOneVal = ''
      this.tableData.search = ''
      this.sortKey = 'updated_at'
      this.tableData.sortDir = 'desc'
      this.tableData.column = 'updated_at'
      this.tableData.from_date = ''
      this.tableData.to_date = ''
      this.tableData.wh_dt_passed = '0'
      this.getResults()
    },

    openGenerateQrCodeModal() {
      if (this.qrCodeValues.length < 1) {
        swal({
          text: 'Please at least select one order!',
          icon: 'warning',
          dangerMode: true,
        })
      } else {
        this.generateQrCodeModal = true
      }
    },

    closeGenerateQrCodeModal() {
      this.generateQrCodeModal = false
      this.qrCodeValues = []
    },

    generateQrCode() {
      this.closeGenerateQrCodeModal()
    },

    openSendToWarehouseModal() {
      this.sendToWarehouseModal = true
    },

    closeSendToWarehouseModal() {
      this.sendToWarehouseModal = false
      this.sendToWarehouseData.qrcode = ''
      this.$validator.reset()
    },

    sendToWarehouse() {
      let token = localStorage.getItem('access_token')

      axios
        .put(this.sendToWarehouseUrl, this.sendToWarehouseData, {
          headers: { Authorization: 'Bearer ' + token },
        })
        .then((response) => {
          this.sendToWarehouseData.qrcode = ''
          this.orderData = response.data.message.order
          this.takePhotoModal = true
          this.getResults()
          if (response.data.message.process_note && response.data.message.process_note.length > 0) {
            swal('Warning', response.data.message.process_note)
          }
        })
        .catch((error) => {
          this.sendToWarehouseData.qrcode = ''

          swal('Error', `${error.response.data.message}`, 'error')
        })
    },

    openCancelingOrderModal(orderId) {
      this.cancelOrderModal = true
      this.theCancelOrderID = orderId
    },

    closeCancelingOrderModal() {
      this.cancelOrderModal = false
      this.cancelAlert = false
      this.cancelData.cancel_reason = ''
    },

    cancelingOrder() {
      let token = localStorage.getItem('access_token')
      axios
        .put('api/canceling_order_by_admin/' + this.theCancelOrderID, this.cancelData, {
          headers: { Authorization: 'Bearer ' + token }
        })
        .then(() => {
          this.getResults()
          this.cancelAlert = true
          setTimeout(() => {
            this.closeCancelingOrderModal()
          }, 1500)
        }).catch(error => {
          swal('Error', `${error.response.data.message}`, 'error')
        })
    },

    openRefundOrderModal(orderId, totalAmount) {
      let token = localStorage.getItem('access_token')
      axios.get(`api/order/${orderId}/partial-refunds`, { headers: { Authorization: 'Bearer ' + token } }).then(res => {
        this.refundData = {
          partial_refunds: res.data.data.partial_refunds,
          send_sms: false
        }
        this.the_order_id = orderId
        this.theOrderTotalAmount = totalAmount
        this.refundOrderModal = true
      })
    },

    closeRefundOrderModal() {
      this.refundOrderModal = false
      this.checkAlert = false
      this.clear()
    },

    clear() {
      this.refundData.refund_reason = ''
      this.refundData.money_amount = ''
      this.refundData.refund_note = ''
      this.theOrderTotalAmount = ''
      this.$validator.reset()
    },

    refundOrder() {
      let token = localStorage.getItem('access_token')
      this.loading = true
      axios
        .put(this.refundOrderUrl + '/' + this.the_order_id, this.refundData, {
          headers: { Authorization: 'Bearer ' + token },
        })
        .then((response) => {
          this.getResults()
          this.checkAlert = true
          this.loading = false
          this.clear()
          let self = this
          setTimeout(() => {
            self.closeRefundOrderModal()
          }, 1500)
        })
        .catch((error) => {
          if (error.response) {
            swal('Error', `${error.response.data.message}`, 'error')
          }
        })
    },

    openAddBarcodeModal(id, barcode) {
      this.addBarcodeModal = true
      this.the_order_id2 = id
      this.addBarcodeData.barcode = barcode
    },

    closeAddBarcodeModal() {
      this.addBarcodeModal = false
      this.addBarcodeData.barcode = ''
      this.checkAlert = false
    },

    addBarcode() {
      let token = localStorage.getItem('access_token')

      axios
        .put(this.addBarcodeUrl + '/' + this.the_order_id2, this.addBarcodeData, {
          headers: { Authorization: 'Bearer ' + token },
        })
        .then(() => {
          this.getResults()
          this.checkAlert = true
          setTimeout(() => {
            this.closeAddBarcodeModal()
          }, 1500)
        })
        .catch((error) => {
          this.addBarcodeData.barcode = ''
          swal('Error', `${error.response.data.message}`, 'error')
        })
    },

    openAddTrackNumberModal(id, trackNumber) {
      this.addTrackNumberModal = true
      this.the_order_id3 = id
      this.addTrackNumberData.track_number = trackNumber
    },

    closeAddTrackNumberModal() {
      this.addTrackNumberModal = false
      this.addTrackNumberData.track_number = ''
      this.checkAlert = false
    },

    addTrackNumber() {
      let token = localStorage.getItem('access_token')

      axios
        .put(this.addTrackNumberUrl + '/' + this.the_order_id3, this.addTrackNumberData, {
          headers: { Authorization: 'Bearer ' + token },
        })
        .then(() => {
          this.getResults()
          this.checkAlert = true
          setTimeout(() => {
            this.closeAddTrackNumberModal()
          }, 1500)
        })
        .catch((error) => {
          this.addTrackNumberData.track_number = ''
          swal('Error', `${error.response.data.message}`, 'error')
        })
    },

    modal(modal) {
      $('#' + modal).modal({ backdrop: 'static' })
    },

    closeModal(modal) {
      let theModal = $('#' + modal)
      theModal.modal('toggle')
    },

    initDetail(modal, id) {
      let token = localStorage.getItem('access_token')
      axios
        .get(this.orderDetailUrl + '/' + id, { headers: { Authorization: 'Bearer ' + token } })
        .then((response) => {
          let data = response.data
          this.detailResults = data.data
          this.detialData = this.detailResults[0]
        })
      this.modal(modal)
    },

    perPageFix(perPage) {
      this.tableData.per_page = perPage
      this.getResults()
    },

    changePage(pageUrl) {
      this.url = pageUrl
      this.getResults()
    },

    searchMe(str) {
      this.tableData.searchOneCol = ''
      this.tableData.searchOneVal = ''
      if (str.trim() != '') {
        this.tableData.search = str
        this.prevSearchQuery = str
        this.getResults()
      } else {
        swal({
          text: 'Type something to search!',
          icon: 'warning',
          dangerMode: true,
        })
        if (this.prevSearchQuery !== '') {
          this.tableData.search = ''
          this.prevSearchQuery = ''
          this.getResults()
        }
      }
    },

    sortByColumn(str) {
      this.tableData.column = str
      this.tableData.sortKey = str
      this.tableData.sortDir = this.tableData.sortDir === 'desc' ? 'asc' : 'desc'
      this.getResults()
    },

    searchOneCol(columnName, str) {
      this.tableData.searchOneCol = columnName
      this.tableData.searchOneVal = str
      this.getResults()
    },

    filterTable(fromDate, toDate) {
      this.tableData.from_date = fromDate
      this.tableData.to_date = toDate
      this.getResults()
    },

    configPagination(data) {
      this.pagination.lastPage = data.last_page
      this.pagination.currentPage = data.current_page
      this.pagination.total = data.total
      this.pagination.lastPageUrl = data.last_page_url
      this.pagination.nextPageUrl = data.next_page_url
      this.pagination.prevPageUrl = data.prev_page_url
      this.pagination.from = data.from
      this.pagination.to = data.to
    },

    checkAll() {
      for (let i = 0; i < this.apiResults.length; i++) {
        if (!$('#cb' + i).is(':checked')) {
          $('#cb' + i).click()
        }
      }
    },

    unCheckAll() {
      for (let i = 0; i < this.apiResults.length; i++) {
        if ($('#cb' + i).is(':checked')) {
          $('#cb' + i).click()
        }
      }
    },
  },
}
</script>

<style>
.table-tr:hover .action-td {
  position: sticky;
  right: -2px;
}
.panel-heading {
  color: #006b8d;
  border-bottom: 2px solid #006b8d !important;
}

.panel-heading h4 {
  text-transform: uppercase;
  margin-left: -20px;
  padding-left: 10px;
  font-weight: 500;
}

.col-xs-12 {
  padding-top: 10px;
  padding-bottom: 10px;
}
.overlay--active:before {
  opacity: 50 !important;
  background: rgba(0, 0, 0, 0.5) !important;
}
.dialog {
  box-shadow: 0 3px 5px -1px rgba(14, 14, 14, 0.212) !important;
  overflow: hidden;
  overflow-y: hidden;
}

.page-stats {
  align-items: center;
  position: relative;
  top: -8px;
  margin-right: 5px;
}

a:hover {
  color: #03a9f4;
  position: relative;
}
a[tooltip]:hover:after {
  content: attr(tooltip);
  padding: 8px 12px;
  color: #ffffff;
  position: absolute;
  right: 80%;
  bottom: 150%;
  white-space: nowrap;
  z-index: 20;
  -moz-border-radius: 3px;
  -webkit-border-radius: 3px;
  border-radius: 3px;
  -moz-box-shadow: 0px 0px 2px #484b4e;
  -webkit-box-shadow: 0px 0px 2px #484b4e;
  box-shadow: 0px 0px 2px #484b4e;
  background-image: -moz-linear-gradient(top, #484b4e, #484b4e);
  background-image: -webkit-gradient(
    linear,
    left top,
    left bottom,
    color-stop(0, #484b4e),
    color-stop(1, #484b4e)
  );
  background-image: -webkit-linear-gradient(top, #484b4e, #484b4e);
  background-image: -moz-linear-gradient(top, #484b4e, #484b4e);
  background-image: -ms-linear-gradient(top, #484b4e, #484b4e);
  background-image: -o-linear-gradient(top, #484b4e, #484b4e);
}

@media screen and (max-width: 767px) {
  .form-group {
    margin-top: 0;
    margin-bottom: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/purchasedOrder.vue